import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isMoney', (values, value) => {
  if (!value || value === '') return true
  if (value === '-') return false
  return value.replace(/,/g, '').match(/^[0-9-]+$/)
})
